import FMI_ACTIONS from '../actions';

const congdoanReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case FMI_ACTIONS.CONGDOAN__GET_ALL_KHAN_DONG_SUCCESS: {
            return {
                ...state,
                ...{ khanDongs: payload.data },
            };
        }
        default:
            return state;
    }
};

export default congdoanReducer;
